import { render, staticRenderFns } from "./cialdetrelans.vue?vue&type=template&id=7b8a603a&scoped=true&"
import script from "./cialdetrelans.vue?vue&type=script&lang=js&"
export * from "./cialdetrelans.vue?vue&type=script&lang=js&"
import style0 from "./cialdetrelans.vue?vue&type=style&index=0&id=7b8a603a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a603a",
  null
  
)

export default component.exports